import { api } from "../api/requests";

//get All Settlements
export async function getAllSettlements(page?: number, size?: number, brokerId?: number, companyId?: number, fromDate?: string, toDate?: string, isPaid?: string, isApproved?: boolean, reviewStage?: string, reference?: string,): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements?page=${page}&size=${size}${brokerId ? `&brokerId=${brokerId}` : ''}${companyId ? `&companyId=${companyId}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${isApproved ? `&isApproved=${isApproved}` : ''}${isPaid ? `&isPaid=${isPaid}` : ''}${reviewStage ? `&reviewStage=${reviewStage}` : ''}${toDate ? `&toDate=${toDate}` : ''}${reference ? `&reference=${reference}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//get Settlement By Id
export async function getSettlementById(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/${id}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//approve Payout
export async function approvePayout(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/${id}/approve`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Complete a settlement payout
export async function completeSettlement(id: string, payload: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/${id}/complete`, payload)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Confirm received payout
export async function confirmReceivedPayout(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/${id}/confirm-receipt`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Mark payout as paid
export async function markPayoutAsPaid(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/${id}/mark-paid`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Review insurer payout
export async function reviewInsurerPayout(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/${id}/review`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Upload insurer payout document
export async function uploadInsurerPayoutDocument(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/${id}/upload-payment-document`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Get payout commissions
export async function payoutCommissions(payoutId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/${payoutId}/commissions`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Get commission payout summary for date range
export async function commissionPayoutSummary(startDate: string, endDate: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/commissions/payout-summary?startDate=${startDate}&endDate=${endDate}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

export async function resetCommissionPayouts(startDate: string, endDate: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/commissions/reset-payouts?startDate=${startDate}&endDate=${endDate}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Generate team payout
export async function generateTeamPayout(teamId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/companies/${teamId}/generate-payout`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Get agency payout account
export async function getAgencyPayoutAccount(teamId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/companies/${teamId}/payment-accounts`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Get agency payouts for company
export async function getAgencyPayouts(teamId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/companies/${teamId}/payouts`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Get specific company payout
export async function getSpecificCompanyPayout(teamId: string, payoutId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/companies/${teamId}/payouts/${payoutId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Approve company payout
export async function approveCompanyPayout(teamId: string, payoutId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.patch(`admin/settlements/companies/${teamId}/payouts/${payoutId}/approve`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Mark company payout as paid
export async function markCompanyPayoutAsPaid(teamId: string, payoutId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.patch(`admin/settlements/companies/${teamId}/payouts/${payoutId}/paid`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Review company payout
export async function reviewCompanyPayout(teamId: string, payoutId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.patch(`admin/settlements/companies/${teamId}/payouts/${payoutId}/review`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Create agency payout account
export async function createAgencyPayoutAccount(teamId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/settlements/companies/${teamId}/payment-accounts`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Update agency payout account
export async function updateAgencyPayoutAccount(teamId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/settlements/companies/${teamId}/payment-accounts`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Delete agency payout account
export async function deleteAgencyPayoutAccount(teamId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/settlements/companies/${teamId}/payment-accounts`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Get payout by reference
export async function getPayoutByReference(reference: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/reference/${reference}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

//Reset sale item
export async function resetSaleItem(saleId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/sale/${saleId}/reset`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}


//Get payout statistics
export async function getSettlementStatistics(brokerId?: string, fromDate?: string, toDate?: string, insuranceCompanyId?: string, isApproved?: boolean, isPaid?: boolean): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/settlements/metrics?${brokerId ? `brokerId=${brokerId}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}${insuranceCompanyId ? `&insuranceCompanyId=${insuranceCompanyId}` : ''}${isApproved ? `&isApproved=${isApproved}` : ''}${isPaid ? `&isPaid=${isPaid}` : ''}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}






